import { useI18n } from '@change-corgi/core/react/i18n';
import { PageMessage } from '@change-corgi/design-system/components/alerts';

import { PetitionUnderReviewBanner } from 'src/app/shared/components/banners/petitionUnderReview';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const {
		data: { showDeleteConfirmMessage, showUnderReviewBanner },
	} = usePageBanner();
	const { translate } = useI18n();

	return (
		<>
			{showUnderReviewBanner && <PetitionUnderReviewBanner />}
			{showDeleteConfirmMessage && (
				<PageMessage
					id="comments-delete-success-banner"
					role="alert"
					message={translate('fe.components.comment.successful_delete')}
					severity="success"
					data-testid="comments-delete-success-banner"
					data-qa="comments-delete-success-banner"
				/>
			)}
		</>
	);
}
